import {Component, Input} from '@angular/core';

@Component({
  selector: 'no-results',
  templateUrl: 'no-results.html'
})
export class NoResultsComponent {

  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() description: string = '';

  constructor() {

  }

}



// WEBPACK FOOTER //
// ./src/components/no-results/no-results.ts